export default {
	add_to_your_calendar: "Añadir a tu calendario",
	explore_all_our_universe_of_courses_videos_articles_and_exclusive_files: "Explora nuestro universo de entrenamientos, videos, artículos y archivos exclusivos.",
	no_events_available_for_the_selected_date: "No hay eventos disponibles.",
	welcome_to: "Bienvenido(a) a",
	what_do_you_want_to_learn_today: "¿Qué quieres aprender hoy?"
}